import type { PhotoPickerCopy } from './types';

export const DEFAULT_PHOTO_PICKER_COPY: PhotoPickerCopy = {
  triggerEmptyLabel: 'Tap to upload your photo(s)',
  triggerAddMoreLabel: 'Edit photos',
  drawerTitle: 'Upload your photos',
  drawerHeading: 'Confirm these are the photos you want to use',
  drawerSubDescription: 'Hold and drag any photo to reorder',
  drawerDescription: 'Add the photos you want printed on this item.',
  dropzoneEmptyTitle: 'Drop photos here',
  dropzoneEmptyBody: 'or tap to choose from your device',
  dropzoneAddMoreLabel: 'Add more photos',
  cancelLabel: 'Cancel',
  confirmLabel: 'Confirm',
  deleteLabel: 'Remove photo',
  uploadingLabel: 'Uploading…',
  uploadErrorMessage: 'Something went wrong. Please try again later.',
  presignErrorMessage: "We couldn't prepare the upload. Please try again.",
};
